import { ID, LinkedItemSection } from '@griply/types';

import { SectionedEntity } from './build-section-update';

export type SectionRenameUpdate = {
  id: ID;
  sections: LinkedItemSection[];
};

// `sections` is an absolute replacement (same contract as
// buildSectionDeleteUpdate); unknown section ids leave the array unchanged.
export const buildSectionRenameUpdate = (
  entity: SectionedEntity,
  sectionId: ID,
  name: string,
): SectionRenameUpdate => ({
  id: entity.id,
  sections: (entity.sections ?? []).map((section) =>
    section.id === sectionId ? { ...section, name } : section,
  ),
});
